import React from 'react';
import { Control } from 'react-hook-form';
import makeStyles from '@material-ui/core/styles/makeStyles';
import RadioButton from './RadioButton';

const useStyles = makeStyles((theme: any) => ({
  group: {
    display: 'flex',
    flexDirection: ({ direction }: any) => {
      return direction === 'row' ? 'row' : 'column';
    },
  },
  gridGroup: {
    display: 'grid',
    gridTemplateColumns: ({ itemPerRow }: any) => `repeat(${itemPerRow}, 1fr)`,
    columnGap: theme.spacing(1),
  },
  option: {
    width: '100%',
    marginTop: theme.spacing(1),
    marginBottom: ({ direction }: any) => {
      return direction === 'row' ? 0 : theme.spacing(1);
    },
    marginRight: ({ direction }: any) => {
      return direction === 'row' ? theme.spacing(2) : 0;
    },
  },
}));

interface Option {
  id: string;
  text?: string | React.ReactNode;
  tooltip?: string;
  dataAutomationId?: string;
}

interface RadioGroupProps {
  groupId: string;
  options: Array<Option>;
  setValue: (id: string, name: string) => void;
  useWatch: ({ control: Control, name: string }) => any;
  control: Control;
  direction?: string;
  buttonContentDirection?: string;
  itemPerRow?: number;
}

export default function RadioGroup({
  groupId,
  options,
  setValue,
  control,
  useWatch,
  direction = 'column',
  buttonContentDirection = 'row',
  itemPerRow = null,
}: RadioGroupProps) {
  const classes = useStyles({ direction, itemPerRow });

  return (
    <div className={itemPerRow ? classes.gridGroup : classes.group}>
      {options.map((option, id) => (
        <div className={classes.option} key={id}>
          <RadioButton
            id={groupId}
            name={option.id}
            text={option?.text}
            tooltipText={option?.tooltip}
            setValue={setValue}
            control={control}
            useWatch={useWatch}
            flexDirection={buttonContentDirection}
            dataAutomationId={option?.dataAutomationId}
          />
        </div>
      ))}
    </div>
  );
}
